const wording = {
  pro: {
    de: 'Pro',
    en: 'Pro',
  },

  message: {
    de: 'Nachricht',
    en: 'Message',
  },
  proDesc: {
    de: 'Für Fotografen, die ihre Qualität steigern und große Projekte organisieren wollen',
    en: 'For photographers who want to increase their quality and organize large projects',
  },
  agb: {
    de: 'Unsere AGB',
    en: 'Terms of Use',
  },
  contactUsSuccess: {
    en: 'Your message has been sent successfully. We will get back to you soon.',
    de: 'Ihre Nachricht wurde erfolgreich gesendet. Wir werden uns bald bei Ihnen melden.',
  },
  contactUsMessagePlaceholder: {
    de: 'itte geben Sie hier Ihre Nachricht ein...',
    en: 'Please enter your message here...',
  },
  aiFaceRecognition: {
    de: 'KI-Gesichtserkennung',
    en: 'AI Face Recognition',
  },
  aiFaceRecognitionDescription: {
    de: 'Unsere innovative Gesichtserkennungstechnologie macht es Kunden leicht, ihre Bilder zu finden. Ein Selfie genügt, und die passenden Bilder werden schnell angezeigt - für ein optimiertes und personalisiertes Kundenerlebnis.',
    en: 'Our innovative face recognition technology makes it easy for clients to find their photos. A selfie is all it takes to quickly display matching images - providing an optimized and personalized customer experience.',
  },
  aiFaceRecognitionTitle: {
    de: 'KI-gestützte Gesichtserkennung',
    en: 'AI-Powered Face Recognition',
  },
  allInOneCustomerManagement: {
    de: 'All-in-One Kundenmanagement: Verwalten Sie Kunden und Aufträge an einem zentralen Ort für nahtlose Kommunikation.',
    en: 'All-in-One Customer Management: Manage clients and orders centrally for seamless communication.',
  },
  analyticsDashboardDescription: {
    de: 'Erhalten Sie einen umfassenden Überblick über Ihre geschäftlichen Aktivitäten und Kunden. Die Analysefunktionen helfen Ihnen, die Entwicklung Ihres Geschäfts zu verfolgen und zu optimieren.',
    en: 'Get a comprehensive overview of your business activities and clients. Analytics features help you monitor and optimize your business growth.',
  },
  analyticsDashboardTitle: {
    de: 'Dashboard mit Statistiken und Analysen',
    en: 'Dashboard with Statistics and Analytics',
  },
  autoLogoOnImages: {
    de: 'Wasserzeichenschutz',
    en: 'Watermark Protection',
  },
  telefonNumber: {
    de: 'Telefonnummer',
    en: 'Phone Number',
  },
  autoLogoHint: {
    de: 'Schick uns dein Logo per E-Mail, und wir platzieren es in deinem Bereich.',
    en: 'Send us your logo via email, and we will place it.',
  },

  automateWorkflow0: {
    de: 'Automatisieren Sie Workflows und sparen Sie Zeit',
    en: 'Automate workflows and save time',
  },

  automateWorkflow: {
    de: 'Zeit sparen durch automatisierte Workflows',
    en: 'Save time with automated workflows',
  },

  liteDesc: {
    de: 'Perfekt für Fotografen, die ihre Reise beginnen und erweitern möchten.',
    en: 'Perfect for photographers who are starting their journey and want to expand.',
  },
  lite: {
    de: 'Lite',
    en: 'Lite',
  },
  brandingAndWatermarkDescription: {
    de: 'Schützen Sie Ihre Bildrechte und stärken Sie Ihre Marke mit automatisch platzierten Wasserzeichen auf allen Bildern - ohne externe Software. So bleibt Ihr Logo stets präsent und Ihre Arbeit professionell gebrandet.',
    en: 'Protect your image rights and strengthen your brand with automatically placed watermarks on all images - no external software needed. Your logo remains visible, ensuring your work is consistently branded professionally.',
  },
  brandingAndWatermarkTitle: {
    de: 'Individuelles Branding und automatisches Wasserzeichen',
    en: 'Custom Branding and Automatic Watermarking',
  },
  brandWithWatermark0: {
    de: 'Präsentieren Sie Ihre Marke mit personalisierten Wasserzeichen und Alben',
    en: 'Showcase your brand with personalized watermarks and albums',
  },

  brandWithWatermark: {
    de: 'Ihre Marke im Fokus mit personalisierten Wasserzeichen',
    en: 'Put your brand in focus with personalized watermarks',
  },

  builtByCreatives: {
    de: 'Entwickelt von Profis für Profis',
    en: 'Built by creatives for creatives',
  },
  calendarAndRemindersDescription: {
    de: 'Behalten Sie Ihre geplanten Events und Aufgaben mit einem integrierten, synchronisierten Kalender im Blick. Erinnerungen helfen Ihnen, Ihre Produktivität zu steigern und keine wichtigen Termine zu verpassen.',
    en: 'Keep track of your scheduled events and tasks with an integrated, synchronized calendar. Reminders help boost productivity and ensure you never miss an important appointment.',
  },
  calendarAndRemindersTitle: {
    de: 'Kalender- und Erinnerungsfunktionen',
    en: 'Calendar and Reminder Features',
  },
  calendarIntegration: {
    de: 'Kalender-Integration',
    en: 'Calendar Integration',
  },
  clientRequests: {
    de: 'Kundenanfragen',
    en: 'Client Requests',
  },
  comprehensiveDashboard: {
    de: 'Umfassendes Dashboard',
    en: 'Comprehensive Dashboard',
  },
  liteIncludes: {
    en: '<strong>Lite</strong> includes:',
    de: 'Im <strong>Lite Tarif</strong> enthalten:',
  },
  allFromLite: {
    de: 'Alles aus dem <strong>Lite Tarif</strong> sowie',
    en: 'Everything in <strong>Lite plan</strong>, and',
  },
  allFromPro: {
    de: 'Alles aus dem <strong>Pro Tarif</strong> sowie',
    en: 'Everything in <strong>Pro plan</strong>, and',
  },
  contactForCustomPlan: {
    de: 'Kontaktieren Sie uns für einen maßgeschneiderten Plan, der zu Ihnen passt!',
    en: 'Contact us for a tailored plan!',
  },
  contactUs: {
    de: 'Kontaktieren Sie uns',
    en: 'Contact Us',
  },
  contact: {
    de: 'Kontakt',
    en: 'Contact',
  },
  contractManagementDescription: {
    de: 'Erstellen, teilen und unterschreiben Sie Verträge elektronisch - einfach und papierlos. So integrieren Sie den gesamten Vertragsprozess nahtlos in Ihren Workflow.',
    en: 'Create, share, and sign contracts electronically - simple and paperless. Seamlessly integrate the entire contract process into your workflow.',
  },
  contractManagementTitle: {
    de: 'Digitale Vertragsverwaltung',
    en: 'Digital Contract Management',
  },
  crm: {
    de: 'CRM (Kundenverwaltung)',
    en: 'CRM (Customer Management)',
  },
  ctaDescription: {
    de: 'Überzeugen Sie sich selbst von den Vorteilen, die Fotogram bietet. Starten Sie jetzt Ihre 30-tägige kostenlose Testphase und erleben Sie, wie Fotogram Ihr Fotografiegeschäft auf ein neues Niveau hebt.',
    en: 'Experience the benefits Fotogram offers for yourself. Start your 30-day free trial now and see how Fotogram takes your photography business to the next level.',
  },
  customBrand: {
    de: 'Eigenes Design und Branding',
    en: 'Custom Design and Branding',
  },
  customDomain: {
    de: 'Eigene Domain',
    en: 'Custom Domain',
  },
  customerManagementDescription: {
    de: 'Verwalten Sie alle Kundeninformationen und Auftragsdetails an einem zentralen Ort. So verbessern Sie Ihre Marketingstrategien und gestalten die Kundenkommunikation effizienter.',
    en: 'Manage all customer information and order details in a single location, enhancing your marketing strategies and streamlining customer communication.',
  },
  customerManagementTitle: {
    de: 'Umfassendes Kundenverwaltung (CRM)',
    en: 'Comprehensive Customer Management (CRM)',
  },
  customized: {
    de: 'Individuell',
    en: 'Customized',
  },
  digitalAlbum: {
    de: 'Digitales Album',
    en: 'Digital Album',
  },
  digitalAlbumsDescription: {
    de: 'Erstellen Sie beeindruckende digitale Alben für Ihre Kunden mit mehr als 400 anpassbaren Vorlagen. Präsentieren Sie Ihre Fotos in professionellen und kreativen Designs, die Ihren Workflow beschleunigen und die Kundenzufriedenheit steigern.',
    en: 'Create impressive digital albums for your clients with over 400 customizable templates. Present your photos in professional and creative designs that enhance your workflow and increase client satisfaction.',
  },
  digitalAlbumsTitle: {
    de: 'Digitale Alben mit über 400 Vorlagen',
    en: 'Digital Albums with Over 400 Templates',
  },
  digitalBusinessCard: {
    de: 'Digitale Visitenkarte',
    en: 'Digital Business Card',
  },
  digitalBusinessCardDescription: {
    de: 'Eine digitale Visitenkarte bündelt Ihre sozialen Kanäle und Kontaktdaten, um die Gewinnung neuer Kunden zu erleichtern und bestehende Kontakte zu pflegen.',
    en: 'A digital business card aggregates your social channels and contact details, making it easier to acquire new clients and maintain existing contacts.',
  },
  digitalBusinessCardTitle: {
    de: 'Digitale Visitenkarte',
    en: 'Digital Business Card',
  },
  digitalContract: {
    de: 'Digitaler Vertrag',
    en: 'Digital Contract',
  },
  digitalShop: {
    de: 'Digitaler Shop für Zusatzverkäufe: Bieten Sie Druckservices und Produkte direkt über die Plattform an, mit integriertem Bezahlsystem.',
    en: 'Digital Shop for Additional Sales: Offer print services and products directly through the platform with integrated payment.',
  },
  digitalShopDescription: {
    de: 'Bieten Sie Ihre Druckservices oder Produkte direkt über Fotogram an und profitieren Sie von 24/7-Verkäufen mit einem integrierten Bezahlsystem über Stripe oder Ihr Kreditinstitut.',
    en: 'Offer your print services or products directly through Fotogram and benefit from 24/7 sales with an integrated payment system via Stripe or your banking institution.',
  },
  digitalShopTitle: {
    de: 'Digitaler Shop für Zusatzverkäufe',
    en: 'Digital Shop for Additional Sales',
  },
  downloadAllImages: {
    de: 'Alle Bilder herunterladen',
    en: 'Download All Images',
  },
  smarttag: {
    de: 'Intelligentes Personen-Tagging',
    en: 'Smart Person Tagging in Images',
  },

  downloadSelectedImages: {
    de: 'Ausgewählte Bilder herunterladen',
    en: 'Download Selected Images',
  },

  month: {
    de: 'Monat',
    en: 'Month',
  },

  year: {
    de: 'Jahr',
    en: 'Year',
  },

  vat: {
    de: 'zzgl. MwSt.',
    en: 'plus VAT',
  },

  private: {
    de: 'Privat',
    en: 'Personal',
  },

  business: {
    de: 'Business',
    en: 'Business',
  },

  monthlyPayment: {
    de: 'Monatlich bezahlen und <br /> flexibel bleiben ',
    en: 'Pay Monthly and <br /> Stay Flexible',
  },
  yearlyPayment: {
    de: 'Saison-Modus <br /> Ruhe im Winter',
    en: 'Season Mode <br /> Rest in Winter',
  },
  faq: {
    de: 'FAQs',
    en: 'FAQs',
  },
  feedbackAH: {
    de: 'Ein Fotograf ohne App ist wie ein Fotograf ohne Kamera. Technologischer Fortschritt ist in der Fotografie unverzichtbar',
    en: 'A photographer without an app is like a photographer without a camera. Technological advancement is essential in photography',
  },
  feedbackAweeha: {
    de: 'Die App hat uns geholfen, unsere Markenidentität zu stärken und unser Einkommen zu steigern',
    en: 'The app has helped us strengthen our brand identity and increase our income',
  },
  feedbackBBB: {
    de: 'Die App ist die beste Investition, die wir in unser Projekt getätigt haben',
    en: 'The app is the best investment we made for our business',
  },
  feedbackElfan: {
    de: 'Endlich eine schnelle, fortschrittliche und moderne Methode, um Fotos direkt vom Event mit den Gästen über die App zu teilen',
    en: 'Finally, a fast, advanced, and modern way to share photos live with guests directly from the event using the app',
  },
  feedbackEssam: {
    de: 'Die Kunden sind sehr zufrieden mit der schnellen Lieferung der Fotos',
    en: 'Customers are very happy with the fast photo delivery',
  },
  feedbackHamdan: {
    de: 'Die Auswahl, Lieferung und das Herunterladen von Fotos sind einfacher und schneller geworden',
    en: 'Selecting, delivering, and downloading photos has become easier and faster',
  },
  feedbackNH: {
    de: 'Die Geschwindigkeit und Effizienz bei der Lieferung der Fotos sind entscheidend für die Kontinuität der Fotografie',
    en: 'Speed and productivity in delivering photos are crucial for maintaining continuity in photography',
  },
  feedbackRotana: {
    de: 'Die App ist anwenderfreundlich. Alles, was Fotografen und Kunden brauchen, ist vorhanden',
    en: 'The app is user friendly. Everything photographers and customers need is available',
  },
  feedbackShady: {
    de: 'Heutzutage ist die App für Fotografen unverzichtbar geworden',
    en: 'Nowadays, the app has become essential for photographers',
  },
  flexiblePricingDescription: {
    de: 'Wählen Sie aus verschiedenen Preismodellen - von Lite bis Business - die für Sie passende Lösung. Maßgeschneiderte Optionen unterstützen Fotografen in jeder Entwicklungsphase ihres Geschäfts.',
    en: 'Choose from a variety of pricing models, from Lite to Business, that best suit your needs. Tailored options support photographers at every stage of their business development.',
  },
  flexiblePricingTitle: {
    de: 'Flexibles Preis- und Abonnementmodell',
    en: 'Flexible Pricing and Subscription Model',
  },
  fotogramMission: {
    de: 'Fotogram wurde von erfahrenen Fotografen und kreativen Designern ins Leben gerufen. Wir verstehen die Herausforderungen der Branche, weil wir selbst Teil davon sind. Unsere Mission ist es, genau die Tools zu entwickeln, die Fotografen benötigen, um effizienter zu arbeiten, ihre Marke zu stärken und ihren Kunden ein unvergleichbares Erlebnis zu bieten. Bei Fotogram setzen wir auf praxisnahe Lösungen, die Ihre Arbeit einfacher und professioneller machen.',
    en: 'Fotogram was founded by experienced photographers and creative designers. We understand the challenges of the industry because we are part of it. Our mission is to develop exactly the tools photographers need to work more efficiently, strengthen their brand, and provide their clients with an unparalleled experience. At Fotogram, we focus on practical solutions that make your work simpler and more professional.',
  },
  freeTrial: {
    de: '30 Tage kostenlos testen',
    en: 'Try Free for 30 Days',
  },
  heroTitle0: {
    de: 'Premium Plattform für Effizienz, Branding und Kundenerlebnis',
    en: 'Premium platform for efficiency, branding, and customer experience',
  },

  heroTitle: {
    de: 'Effizienz, Branding, Kundenerlebnis – neu definiert für Fotografen',
    en: 'Efficiency, branding, and client experience – redefined for photographers',
  },

  home: {
    de: 'Startseite',
    en: 'Home',
  },
  imageTagging: {
    de: 'Bild Markierung',
    en: 'Image Tagging',
  },
  imprint: {
    de: 'Impressum',
    en: 'Imprint',
  },
  iosAndroidBrandedApp: {
    de: 'iOS- & Android App',
    en: 'iOS & Android App',
  },
  limitedClients: {
    de: 'Bis zu 3 Kunden',
    en: 'Up to 3 Customers',
  },
  limitedEvents: {
    de: 'Bis zu 5 Veransltaltungen',
    en: 'Up to 5 Events',
  },
  liveEvent: {
    de: 'Live-Event',
    en: 'Live Event',
  },
  liveImageStreamingDescription: {
    de: 'Laden Sie Bilder während Veranstaltungen in Echtzeit hoch und ermöglichen Sie Ihren Kunden, diese sofort anzusehen, herunterzuladen oder zu teilen. Gäste können mit einem QR-Code auf Bilder in hoher Auflösung zugreifen. Zusätzlich bietet Fotogram Live-Video-Streaming für besondere Events.',
    en: 'Upload images in real time during events and allow your clients to instantly view, download, or share them. Guests can access high-resolution images via a QR code. Additionally, Fotogram offers live video streaming for special events.',
  },
  liveImageStreamingTitle: {
    de: 'Live-Bildübertragung und Streaming',
    en: 'Live Image Transmission and Streaming',
  },
  liveVideoStreaming: {
    de: 'Live-Video-Streaming',
    en: 'Live Video Streaming',
  },
  ourStory: {
    de: 'Unsere Geschichte',
    en: 'Our Story',
  },
  ourVisionDescription: {
    de: 'Fotogram ist mehr als eine Plattform - es ist eine Auszeichnung für Fotografen, die ihr Geschäft effizienter gestalten, ihre Marke stärken und ihren Kunden ein exklusives Erlebnis bieten möchten. Mit modernsten Funktionen und einer luxuriösen Nutzererfahrung ermöglicht Fotogram Fotografen, ihre Arbeit auf höchstem Niveau zu präsentieren und ihr Einkommen nachhaltig zu steigern. Unsere Server in Deutschland gewährleisten dabei höchste Sicherheitsstandards und Datenschutz.',
    en: 'Fotogram is more than a platform - it’s an accolade for photographers who wish to improve their business efficiency, strengthen their brand, and offer an exclusive experience to their clients. Equipped with state-of-the-art features and a premium user experience, Fotogram enables photographers to showcase their work at the highest level and sustainably increase their income. Our servers in Germany guarantee top security standards and data protection.',
  },
  ourVisionTitle: {
    de: 'Unsere Vision und Kernfunktionen im Blick',
    en: 'Our Vision and Core Features in Focus',
  },
  photographerDescription: {
    de: 'Fotografie und Produktion',
    en: 'Photography and Production',
  },
  photographerPrintDescription: {
    de: 'Fotografie, Produktion und Druck',
    en: 'Photography, Production and Printing',
  },
  plans: {
    de: 'Preispläne',
    en: 'Plans',
  },
  businessDesc: {
    de: 'Für professionelle Fotografen und Unternehmen, die sich abheben möchten.',
    en: 'For professional photographers and businesses who want to stand out.',
  },
  pricing: {
    de: 'Preise',
    en: 'Pricing',
  },
  privacyPolicy: {
    de: 'Datenschutz',
    en: 'Privacy Policy',
  },
  privateMember: {
    de: '1 Mitglied',
    en: '1 Member',
  },
  privateUse: {
    de: 'Privat',
    en: 'Private',
  },
  privateUseDesc: {
    de: 'Für Privatpersonen, die ihre Fotos sicher speichern und jederzeit darauf zugreifen möchten',
    en: 'For individuals who want to securely store their photos and access them anytime',
  },
  quickImageDelivery: {
    de: 'Schnelle Bildlieferung und Live-Erlebnisse: Teilen Sie Eventbilder in Echtzeit und lassen Sie Ihre Kunden sofort darauf zugreifen.',
    en: 'Quick Image Delivery and Live Experiences: Share event images in real-time, allowing clients immediate access.',
  },
  realTimeImageDescription: {
    de: 'Teilen Sie Eventbilder sofort mit Ihren Kunden. Dank der Echtzeit-Übertragung können Gäste die Fotos direkt auf ihr Gerät herunterladen, teilen oder für den Druck auswählen. Diese Funktion schafft ein unvergessliches Erlebnis und hebt Ihre Dienstleistungen deutlich hervor.',
    en: 'Share event images instantly with your clients. Thanks to real-time transmission, guests can download, share, or select photos for printing directly on their devices. This feature creates an unforgettable experience and enhances your services significantly.',
  },
  realTimeImageSharing: {
    de: 'Echtzeit-Bildübertragung und Live-Event-Sharing',
    en: 'Real-Time Image Sharing and Live Event Coverage',
  },

  realTimeImageTransmission0: {
    de: 'Bieten Sie Echtzeit Bildübertragung und KI-Gesichtserkennung',
    en: 'Offer real-time image transmission and AI face recognition',
  },

  realTimeImageTransmission: {
    de: 'Live-Momente teilen mit Echtzeit Bildübertragung und intelligente Gesichtserkennung',
    en: 'Share live moments with real-time image transfer and intelligent facial recognition',
  },

  shareMoment: {
    de: 'Teilen Sie den Moment ohne Verzögerung',
    en: 'Share the Moment Without Delay',
  },
  shop: {
    de: 'Shop',
    en: 'Shop',
  },
  shopHint: {
    de: 'Shop Hint',
    en: 'Shop Hint',
  },
  storage1TB: {
    de: '1 TB Speicherplatz',
    en: '1 TB Storage',
  },
  storage1TBHint: {
    de: 'Falls du mehr brauchst, kostet jeder 1 TB nur 34,99 € monatlich',
    en: 'Need more? Each additional 1 TB is only € 34,99 per month',
  },

  storage500GBHint: {
    de: 'Zusätzliche 250 GB gibt’s für nur 6,99 €/Monat oder 500 GB für nur 9,99 €/Monat.',
    en: 'Get an extra 250 GB for just €6.99/month or 500 GB for only €9.99/month.',
  },

  storage2TB: {
    de: '2 TB Speicherplatz',
    en: '2 TB Storage',
  },
  storage2TBHint: {
    de: 'Falls du mehr brauchst, kannst du deinen aktuellen Plan weiter nutzen und nur den Speicherplatz erweitern. Jeder 1 TB kostet nur 34,99 € monatlich. Alternativ kannst du jederzeit auf den Business-Plan wechseln.',
    en: 'Need more? You can keep your current plan and just expand your storage. Each additional 1 TB is only € 34,99 per month. Alternatively, you can switch to the Business plan at any time.',
  },

  storage10GB: {
    de: '10 GB Speicherplatz',
    en: '10 GB Storage',
  },
  storage20GB: {
    de: '50 GB Speicherplatz',
    en: '50 GB Storage',
  },
  storage500GB: {
    de: '500 GB Speicherplatz',
    en: '500 GB Storage',
  },
  storage500GBBHint: {
    de: 'Falls du mehr brauchst, kannst du deinen aktuellen Plan weiter nutzen und nur den Speicherplatz erweitern. Jeder 1 TB kostet nur 34,99 € monatlich. Alternativ kannst du jederzeit auf den Business-Plan wechseln.',
    en: 'Need more? You can keep your current plan and just expand your storage. Each additional 1 TB is only € 34,99 per month. Alternatively, you can switch to the Business plan at any time.',
  },
  streamlinedContractProcessing: {
    de: 'Vereinfachte Vertragsabwicklung: Erstellen, teilen und unterschreiben Sie Verträge digital - effizient und papierlos.',
    en: 'Streamlined Contract Processing: Create, share, and sign contracts digitally, efficiently, and paperlessly.',
  },
  tailoredPlan: {
    de: 'Ein maßgeschneiderter Plan, der auf Ihre Bedürfnisse zugeschnitten ist.',
    en: 'A tailored plan that fits your needs.',
  },
  talkToSupport: {
    de: 'Support kontaktieren',
    en: 'Talk to Sales',
  },
  teamMembers1: {
    de: '1 Teammitglied',
    en: '1 Team Member',
  },
  teamMembers2: {
    de: '2 Teammitglieder',
    en: '2 Team Members',
  },
  teamMembers3: {
    de: '3 Teammitglieder',
    en: '3 Team Members',
  },
  teamMembers3Hint: {
    de: 'Falls das Team größer ist, kostet jedes zusätzliche Mitglied nur 14,99 € monatlich',
    en: 'If the team is larger, each additional member costs only € 14,99 per month',
  },
  testimonialsTitle: {
    de: 'Das sagen unsere Kunden',
    en: 'Trusted by Photographers Around the Globe',
  },
  tryIt: {
    de: 'Jetzt 30 Tage kostenlos testen',
    en: 'Start your free 30 Days trial',
  },
  usernameError: {
    en: 'Username can only contain letters, numbers, and dots',
    de: 'Der Benutzername darf nur Buchstaben, Zahlen und Punkte enthalten',
  },
  username: {
    en: 'Username',
    de: 'Benutzername',
  },
  emailError: {
    en: 'Please enter a valid email address',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  },
  firstName: {
    en: 'First Name',
    de: 'Vorname',
  },
  lastName: {
    en: 'Last Name',
    de: 'Nachname',
  },
  name: {
    en: 'Name',
    de: 'Name',
  },
  email: {
    en: 'Email',
    de: 'E-Mail',
  },

  ftp: {
    en: 'FTP Access',
    de: 'FTP Zugang',
  },

  screenshot: {
    en: 'Disable Screenshots for Events',
    de: 'Bildschirmaufnahme deaktivieren',
  },

  iptc: {
    en: 'IPTC Search',
    de: 'IPTC-Suche',
  },

  contactDetails: {
    en: 'Contact details at Live Event',
    de: 'Kontaktdaten bei Live-Event',
  },

  createdSuccesfully: {
    en: 'Your account has been successfully created. Check your inbox for the login link.',
    de: 'Dein Konto wurde erfolgreich erstellt. Prüfe deinen Posteingang für den Anmeldelink.',
  },

  errorOccured: {
    en: 'An error occurred while creating your account. Please contact us at support@fotogram.app.',
    de: 'Beim Erstellen Ihres Kontos ist ein Fehler aufgetreten. Bitte kontaktieren Sie uns unter support@fotogram.app.',
  },
  oneStep: {
    en: 'Our one-step sign-up only takes a few seconds and is completely free',
    de: 'Unser Ein-Schritt-Anmeldeprozess dauert nur wenige Sekunden und ist komplett kostenlos',
  },
  justGetStarted: {
    en: 'Just get started',
    de: 'Einfach loslegen',
  },
  password: {
    en: 'Password',
    de: 'Passwort',
  },
  passwordError: {
    en: 'Password must be at least 8 characters long, include an uppercase letter, a number, and a special character',
    de: 'Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten',
  },
  hubWelcome: {
    en: 'Welcome to the Hub! Check your email for your password and further details.',
    de: 'Willkommen im Hub! Überprüfen Sie Ihre E-Mails, um Ihr Passwort und weitere Details zu erhalten.',
  },
  privateSignup: {
    en: 'Sign up for Private Package now',
    de: 'Jetzt für das Private-Paket anmelden',
  },
  proSignup: {
    en: 'Sign up for Pro Package now',
    de: 'Jetzt für das Pro-Paket anmelden',
  },
  businessSignup: {
    en: 'Sign up for Business Package now',
    de: 'Jetzt für das Business-Paket anmelden',
  },
  liteSignup: {
    en: 'Sign up for Lite Package now',
    de: 'Jetzt für das Lite-Paket anmelden',
  },
  join5000: {
    en: 'Join 5000+ Happy Hubbers!',
    de: 'Schließen Sie sich über 5000+ glücklichen Hubbern an!',
  },
  joinExperience: {
    en: 'Experience the ultimate photography journey with our attractive package.',
    de: 'Erleben Sie die ultimative Fotografie-Reise mit unserem attraktiven Paket',
  },

  afterJoin: {
    de: 'Nach der Anmeldung erhalten Sie eine E-Mail mit Ihrem Passwort und weiteren Details',
    en: 'After signing up, you will receive an email with your password and further details',
  },

  unlimitedClients: {
    de: 'Unbegrenzte Kunden',
    en: 'Unlimited Clients',
  },
  unlimitedEvents: {
    de: 'Unbegrenzte Veranstaltungen',
    en: 'Unlimited Events',
  },
  videosAndReels: {
    de: 'Videos und Reels',
    en: 'Videos and Reels',
  },
  videosAndReelsHint: {
    de: 'Begrenzt auf 50 MB pro Video für unbegrenzte Anzahl an Videos. Du kannst noch unbegrenzt 3rd Party Links für Videos einbinden, wie z. B. Google Drive, Dropbox, Vimeo, YouTube, Mega usw.',
    en: 'Limited to 50MB per video for an unlimited number of videos. You can add also unlimited third-party video links in the app, such as Google Drive, Dropbox, Vimeo, YouTube, Mega, etc.',
  },

  watermarkFeature: {
    de: 'Personalisierte Wasserzeichen',
    en: 'Personalized Watermarks',
  },

  watermarkFeatureDescription: {
    de: 'Mit Fotogram bleibt Ihre Marke stets präsent. Das Logo des Fotografen wird automatisch auf allen hochgeladenen Bildern als Wasserzeichen platziert - ohne die Notwendigkeit externer Software. Diese Funktion schützt Ihre Bildrechte, stärkt Ihr Branding und spart Ihnen Zeit bei der Nachbearbeitung. So präsentieren Sie Ihre Arbeit professionell und einheitlich, während Sie gleichzeitig sicherstellen, dass Ihr Logo immer mit Ihren Bildern verbunden ist.',
    en: "With Fotogram, your brand remains visible. The photographer's logo is automatically watermarked on all uploaded images, eliminating the need for external software. This feature protects your image rights, reinforces your branding, and saves you time in post-processing. Present your work professionally and consistently while ensuring your logo is always linked with your images.",
  },

  whatFotogramOffers: {
    de: 'Was Fotogram Ihnen bietet',
    en: 'What Fotogram offers you',
  },
  whyFotogram: {
    de: 'Warum Fotogram',
    en: 'Why Fotogram',
  },
  question1: {
    de: 'Wie erstelle ich eine neue Veranstaltung und lade Bilder hoch?',
    en: 'How do I create a new event and upload images?',
  },
  question2: {
    de: 'Können meine Kunden Bilder herunterladen oder für den Druck auswählen?',
    en: 'Can my clients download images or select them for printing?',
  },
  question3: {
    de: 'Wie schützt Fotogram meine Daten und die meiner Kunden?',
    en: 'How does Fotogram protect my data and my clients data?',
  },
  question4: {
    de: 'Welche Abonnementpläne bietet Fotogram an und wie kann ich mein Abo ändern oder kündigen?',
    en: 'What subscription plans does Fotogram offer, and how can I change or cancel my subscription?',
  },

  question5: {
    de: 'Kann ich mein Logo und individuelle Designs auf der Plattform verwenden?',
    en: 'Can I use my logo and custom designs on the platform?',
  },

  question6: {
    de: 'Wie funktioniert die Echtzeit-Bildübertragung auf Veranstaltungen?',
    en: 'How does real-time photo sharing work for events?',
  },

  question7: {
    de: 'Was soll ich tun, wenn ich auf technische Probleme stoße?',
    en: 'What should I do if I encounter technical issues?',
  },
  answer1: {
    de: 'Im Hauptmenü haben Sie als Fotograf Admin-Rechte. Sie können eine Veranstaltung erstellen und anschließend im Uploadbereich die zugehörigen Bilder hochladen.',
    en: 'In the main menu, you have admin rights as a photographer. You can create an event and then upload the associated images in the upload section.',
  },

  answer2: {
    de: 'Ja, Ihre Kunden können sowohl Bilder herunterladen als auch markieren. Sie als Fotograf sehen sofort, welche Bilder markiert wurden. Sie können im Voraus definieren, wie viele Bilder für die Markierung erwartet werden. Sobald der Kunde alle Bilder ausgewählt hat, erhalten Sie eine automatische Benachrichtigung über die App.',
    en: 'Yes, your clients can both download images and mark their favorites. As a photographer, you can immediately see which images have been marked. You can define in advance how many images the client is expected to mark. Once the client has selected all the images, you will receive an automated app notification.',
  },

  answer3: {
    de: 'Unsere Server für das Speichern und Verarbeiten der Bilder befinden sich ausschließlich in Deutschland.',
    en: 'Our servers for storing and processing images are located exclusively in Germany.',
  },
  answer4: {
    de: `Sie können unsere Plattform 30 Tage kostenlos testen und danach entscheiden, ob Sie weitermachen möchten.<br />
        Anschließend können Sie aus unseren verschiedenen Paketen wählen:<br /><br/>
        <strong>Lite</strong>: Perfekt für Fotografen, die ihre Reise beginnen und erweitern möchten.<br />
        <strong>Pro</strong>: Für Fotografen, die ihre Qualität steigern und große Projekte organisieren wollen.<br />
        <strong>Business:</strong> Für professionelle Fotografen und Unternehmen, die sich abheben möchten.<br />
        <strong>Individuell</strong>: Ein maßgeschneiderter Plan, der auf Ihre Bedürfnisse zugeschnitten ist.<br /></br>
        Kontaktieren Sie uns für einen maßgeschneiderten Plan, der zu Ihnen passt!`,

    en: `You can try our platform free for 30 days and decide if you want to continue. After that, you can choose from our different plans:<br />

        Lite: Perfect for photographers starting their journey and looking to grow.<br />
        Pro: For photographers aiming to enhance quality and manage larger projects.<br />
        Business: For professional photographers and businesses wanting to stand out.<br />
        Customized: A tailored plan designed to fit your needs.<br />
        Contact us for a customized plan that suits you best!`,
  },
  answer5: {
    de: 'Nachdem Sie das passende Abonnement abgeschlossen haben, schicken Sie uns Ihr Design und Logo per E-Mail. Innerhalb weniger Stunden sehen Sie Ihr Design auf der Plattform, und Ihr Logo wird automatisch auf alle hochgeladenen Bilder unten links oder in einer anderen gewünschten Ecke angezeigt. Bitte teilen Sie uns per E-Mail mit, wo das Logo erscheinen soll.',
    en: 'After choosing the right subscription, send us your design and logo via email. Within a few hours, you will see your design on the platform, and your logo will automatically appear on all uploaded images in the bottom left or another corner of your choice. Please let us know via email where you would like the logo to appear.',
  },

  answer6: {
    de: 'Nachdem Sie eine Veranstaltung in der Plattform erstellt haben, gehen Sie auf "QR Code erstellen" und aktivieren Sie ihn. Den QR-Code können Sie herunterladen und für die geplante Veranstaltung ausdrucken. Während der Live-Event laden Sie wie gewohnt Bilder in Ihrem Admin-Bereich hoch. Diese erscheinen sofort für die Kunden oder Gäste in der App, nachdem sie den QR-Code gescannt haben. Optional können Sie die KI-Gesichtserkennung aktivieren, sodass die Gäste nur ihre eigenen Bilder sehen, nachdem sie ein Selfie nach dem QR-Scan gemacht haben.',
    en: 'After creating an event on the platform, go to "Generate QR Code" and activate it. You can download the QR code and print it for the planned event. During the live event, upload images as usual in your admin area. These images will instantly appear for clients or guests in the app after scanning the QR code. Optionally, you can activate AI facial recognition, allowing guests to see only their own photos after taking a selfie following the QR scan.',
  },

  answer7: {
    de: 'Schicken Sie uns eine E-Mail oder rufen Sie uns unter der angegebenen Telefonnummer an. Wir stehen Ihnen jederzeit zur Verfügung!',
    en: 'Send us an email or call us at the provided phone number. We are here to assist you anytime!',
  },

  faqsTitel: {
    de: 'Wir sind für Sie da!',
    en: 'We are here for you!',
  },
  faqsDescription: {
    de: `Haben Sie Fragen zu Fotogram? Kein Problem!<br /><br />
      Unser Support-Team steht Ihnen gerne unter <strong>support@fotogram.app</strong> zur Verfügung.<br /><br />
       Bitte schauen Sie, wenn möglich, zuerst in unsere FAQs, bevor Sie uns kontaktieren.<br />
       Wenn Sie uns von der E-Mail-Adresse schreiben, mit der Sie sich registriert haben, können wir Ihnen noch schneller helfen.<br /><br />
       Wir freuen uns darauf, Ihnen zu helfen!`,
    en: `Got questions about Fotogram? No problem!<br /><br />
       Our support team is happy to assist you at <strong>support@fotogram.app</strong>.<br />
       If possible, please check our FAQs before reaching out. Writing from the email address you used to sign up helps us assist you even faster.<br /><br /> We look forward to helping you!`,
  },

  faqsPreQuestions: {
    de: 'Häufig gestellte Fragen',
    en: 'Most Asked Questions',
  },

  whoAreWeTitel: {
    de: 'Wer wir sind?',
    en: 'Who We Are?',
  },

  ourGoalsTitel: {
    de: 'Unsere Ziele',
    en: 'Our Goals',
  },

  ourVisionTitel: {
    de: 'Unsere Vision',
    en: 'Our Vision',
  },

  whoAreWeContent: {
    de: `Fotogram für Softwarelösungen ist nicht nur ein Produkt – es ist die Vision eines Teams von Experten, die 
           sich der Weiterentwicklung der Fotografiebranche verschrieben haben. <br /> <br /> 
           Mit unserer vielfältigen Erfahrung in Fotografie, Medienproduktion und Technologie gestalten wir maßgeschneiderte Lösungen, die speziell auf
           die Bedürfnisse von Fotografen und Studios zugeschnitten sind. <br /> <br /> 
           Unsere Schwerpunkte liegen auf Programmierung, Web- und App-Design, digitalem Marketing und dem Management innovativer Softwareprodukte. <br /><br />  `,

    en: `Fotogram for Software Solutions is more than just a product – it’s the vision of a team of experts
       dedicated to revolutionizing the photography industry. <br /><br />
       With our diverse experience in photography, media production, and technology, we create tailored solutions specifically designed to meet the 
       needs of photographers and studios. <br /> <br />
       Our expertise includes programming, web and app design, digital marketing, and the management of innovative software products. <br />  <br /> `,
  },

  ourGoalsContent: {
    de: `1. Innovation in der Fotografie- und Medienbranche: Wir treiben die Digitalisierung und Optimierung von
          Arbeitsabläufen aktiv voran. <br /><br />
         2. Effizienz für Fotografen: Mit Fotogram können Fotografen Zeit und Kosten sparen, während sie
         gleichzeitig ihre Produktivität steigern. <br /><br />
         3. Stärkung von Kundenbeziehungen: Positive Kundenerfahrungen schaffen nachhaltige Bindungen und stärken den geschäftlichen Erfolg. <br /><br />
         4. Individuelle Anpassung: Unsere Plattform ist professionell, flexibel und an die spezifischen Workflows
          jedes Fotografen oder Studios anpassbar.`,

    en: `1. Innovation in Photography and Media: We actively drive digital transformation and optimize workflows<br />
          in the photography industry. <br /><br />
         2. Efficiency for Photographers: Fotogram helps photographers save time and costs while enhancing
          their productivity. <br /><br />
         3. Strengthening Customer Relationships: Positive client experiences foster long-term connections 
          and strengthen business success.<br /><br />
         4. Customized Solutions: Our platform is professional, flexible, and adaptable to the specific workflows of every photographer or studio.`,
  },

  ourVisionContent: {
    de: `Wir glauben, dass Technologie und Kreativität Hand in Hand gehen. Unsere Mission ist es, 
        Fotografen dabei zu unterstützen, ihre Arbeit auf höchstem Niveau zu präsentieren und dabei
        innovativ und flexibel zu bleiben. Wir sind offen für neue Herausforderungen und freuen uns darauf,
        gemeinsam mit unseren Kunden einzigartige Funktionen und Lösungen zu entwickeln, die perfekt 
        auf ihre Bedürfnisse abgestimmt sind.`,

    en: `We believe that technology and creativity go hand in hand. Our mission is to empower 
        photographers to showcase their work at the highest level while staying innovative and flexible.  
       We are open to new challenges and excited to collaborate with our clients to develop unique features 
       and solutions tailored to their needs.`,
  },

  imageTitelTeamLead: {
    de: 'Eilon Mario Netzer, Teamleiter bei Fotogram<br />- die Vision hinter der Plattform.',
    en: 'Eilon Mario Netzer, Team Lead at Fotogram<br />- the vision behind the platform.',
  },

  teamLeadQuote: {
    de: `<br /><br /><q>Fotografie ist nicht nur Kunst, sondern eine Form, Geschichten zu erzählen. Mit Fotogram 
    möchten wir jedem Fotografen die Werkzeuge bieten, diese Geschichten auf innovative Weise zu präsentieren.</q>`,
    en: `<q>Photography is not just art; it's a way of telling stories. With Fotogram, we aim to provide every
    photographer with the tools to present these stories in innovative ways.</q>`,
  },

  newIdeasTitel: {
    de: 'Immer offen für neue Ideen',
    en: 'Always open to new ideas',
  },

  newIdeasContent: {
    de: `Fotogram steht nicht still. Wir arbeiten ständig an neuen Funktionen und sind immer offen für die
    Ideen und Wünsche unserer Kunden. Sie haben eine spezifische Anforderung oder eine neue Herausforderung?  <br />
    Wir sind bereit, sie mit Ihnen anzugehen.<br /><br />`,
    en: `Fotogram is constantly evolving. We are always working on new features and remain open to the
    ideas and needs of our clients. Have a specific requirement or a new challenge? We’re ready to tackle it with you.<br /><br />`,
  },
  sendMessage: {
    de: 'Nachricht senden',
    en: 'Send Message',
  },
  contactUsError: {
    de: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    en: 'An error occurred. Please try again.',
  },
  phoneNumber: {
    en: 'Phone Number (Optional)',
    de: 'Telefonnummer (Optional)',
  },
  phoneNumberPlaceholder: {
    en: 'Enter your phone number',
    de: 'Geben Sie Ihre Telefonnummer ein',
  },
  phoneNumberHint: {
    en: 'Enter your number for possible inquiries',
    de: 'Geben Sie Ihre Nummer für mögliche Rückfragen ein',
  },
  voucherBundleTitle: {
    en: 'Special Bundle Voucher!',
    de: 'Spezial Bundle Gutschein!',
  },
  voucherExclusiveAccess: {
    en: 'Exclusive access through',
    de: 'Exklusiver Zugang über',
  },
  voucherPromoterLabel: {
    en: 'Promoter',
    de: 'Partner',
  },
  voucherCodeLabel: {
    en: 'Code',
    de: 'Code',
  },
  voucherActivateButton: {
    en: 'Complete Bundle Registration',
    de: 'Bundle-Registrierung abschließen',
  },
  voucherActivateDescription: {
    en: 'Complete your registration to unlock premium Fotogram features included with your bundle',
    de: 'Vervollständigen Sie Ihre Registrierung, um Premium-Fotogram-Funktionen freizuschalten, die in Ihrem Bundle enthalten sind',
  },
  voucherSuccessMessage: {
    en: 'Bundle access activated successfully! Check your email for login details.',
    de: 'Bundle-Zugang erfolgreich aktiviert! Überprüfen Sie Ihre E-Mail für Login-Details.',
  },
  voucherBundleIncludes: {
    en: 'Your Bundle Includes:',
    de: 'Ihr Bundle enthält:',
  },
  voucherUnlimitedEvents: {
    en: 'Unlimited Events',
    de: 'Unbegrenzte Veranstaltungen',
  },
  voucherUnlimitedClients: {
    en: 'Unlimited Clients', 
    de: 'Unbegrenzte Kunden',
  },
  voucher500GBStorage: {
    en: '500 GB Storage',
    de: '500 GB Speicherplatz',
  },
  voucherDownloadAllImages: {
    en: 'Download All Images',
    de: 'Alle Bilder herunterladen',
  },
  errorInvalidVoucherCode: {
    en: 'Invalid voucher code. Please check your code and try again.',
    de: 'Ungültiger Gutscheincode. Bitte überprüfen Sie Ihren Code und versuchen Sie es erneut.',
  },
  errorCompanyExistsAlready: {
    en: 'This subdomain is already taken. Please choose a different one.',
    de: 'Diese Subdomain ist bereits vergeben. Bitte wählen Sie eine andere.',
  },
  errorVoucherGeneric: {
    en: 'An error occurred while activating your bundle access. Please contact support@fotogram.app',
    de: 'Ein Fehler ist beim Aktivieren Ihres Bundle-Zugangs aufgetreten. Bitte kontaktieren Sie support@fotogram.app',
  },
};

export default wording;
